import { useState } from "react";
import { ArrowUpRight } from "lucide-react";

const IMG_A =
  "https://images.unsplash.com/photo-1624213011686-bc14dfc81650?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc3OTkyMDU4fDA&ixlib=rb-4.1.0&q=85";
const IMG_B =
  "https://images.unsplash.com/photo-1760246964044-1384f71665b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc3OTkyMDU4fDA&ixlib=rb-4.1.0&q=85";
const IMG_C =
  "https://images.pexels.com/photos/17483870/pexels-photo-17483870.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_D =
  "https://images.pexels.com/photos/18069816/pexels-photo-18069816.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const INDUSTRIES = [
  { id: 1, name: "Public Sector & Defense", code: "FED", img: IMG_A, copy: "Mission analytics, command-grade dashboards, FedRAMP-aligned data platforms." },
  { id: 2, name: "Financial Services", code: "FIN", img: IMG_B, copy: "Risk, surveillance, and CFO analytics for banks, asset managers and insurers." },
  { id: 3, name: "Healthcare & Life Sciences", code: "MED", img: IMG_C, copy: "HIPAA-grade pipelines, claims intelligence, and trial operations analytics." },
  { id: 4, name: "Energy & Utilities", code: "ENR", img: IMG_D, copy: "Grid telemetry, asset reliability, and ESG reporting at audit precision." },
  { id: 5, name: "Logistics & Mobility", code: "LOG", img: IMG_A, copy: "Network design, fleet utilization, and customs / trade flow analytics." },
  { id: 6, name: "Telecom & Technology", code: "TEC", img: IMG_B, copy: "Subscriber economics, anomaly detection, and product analytics platforms." },
];

export default function Industries() {
  const [active, setActive] = useState(INDUSTRIES[0]);
  return (
    <section id="industries" data-testid="industries-section" className="border-b border-neutral-200 bg-neutral-950 text-white">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-20 md:py-32">
        <div className="flex items-center gap-4 mb-10">
          <span className="font-mono-tech text-xs tracking-[0.2em] uppercase text-neutral-400">
            [04] Industries served
          </span>
          <span className="h-px flex-1 bg-neutral-800" />
        </div>

        <div className="grid grid-cols-12 gap-0 border-t border-neutral-800">
          <ul className="col-span-12 lg:col-span-7 lg:border-r border-neutral-800">
            {INDUSTRIES.map((it) => (
              <li
                key={it.id}
                data-testid={`industry-${it.code.toLowerCase()}`}
                onMouseEnter={() => setActive(it)}
                onFocus={() => setActive(it)}
                tabIndex={0}
                className={`group flex items-center justify-between gap-6 px-2 md:px-4 py-6 md:py-8 border-b border-neutral-800 cursor-pointer transition-colors ${active.id === it.id ? "bg-white text-black" : "hover:bg-neutral-900"}`}
              >
                <div className="flex items-baseline gap-6">
                  <span className={`font-mono-tech text-xs tracking-[0.2em] ${active.id === it.id ? "text-neutral-500" : "text-neutral-500"}`}>
                    /{String(it.id).padStart(2, "0")}
                  </span>
                  <span className="font-display text-2xl md:text-4xl lg:text-5xl font-bold tracking-tight">
                    {it.name}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="hidden md:inline font-mono-tech text-xs tracking-[0.2em] text-neutral-500">
                    {it.code}
                  </span>
                  <ArrowUpRight className="w-5 h-5 opacity-60 group-hover:opacity-100 transition-opacity" />
                </div>
              </li>
            ))}
          </ul>

          <div className="col-span-12 lg:col-span-5 relative min-h-[320px] lg:min-h-[640px]">
            <img
              key={active.id}
              src={active.img}
              alt={active.name}
              className="absolute inset-0 w-full h-full object-cover fade-up"
              data-testid="industry-active-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-neutral-950/90 via-neutral-950/20 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-6 md:p-10">
              <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-300">
                Now showing — {active.code}
              </span>
              <p className="mt-3 max-w-md text-base md:text-lg text-white leading-relaxed">
                {active.copy}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
